import { cva } from '@/styled-system/css';

export const adaptiveAnchorRecipe = cva({
  base: {},
  variants: {
    variant: {
      default: {},
      // Constrain the hit area to the logo so clicking surrounding whitespace doesn't navigate.
      logo: {
        width: 'fit-content',
        height: '1200',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 'obj.default',
      },
    },
  },
});
